module.exports = __webpack_public_path__ + "static/img/A87.f9caf3ca.jpg";